// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2tzbP","productName":"Table_productName__2iLt4"};